import axios from 'axios';
import config from '../../config';
import Cookies from 'js-cookie';
import { getUser, login } from '../authHelper.js'
import toast from 'react-hot-toast';

// content type
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.baseURL = config.API_URL;

console.log(config.API_URL)

// intercepting to capture errors
// axios.interceptors.response.use(
//     (response) => {
//         return response;
//     },
//     (error) => {
//         // Any status codes that falls outside the range of 2xx cause this function to trigger
//         let message;
//         console.log('ERRRRR: ', error)
//         if (error && error.response && error.response.status === 403) {
//             window.location.href = '/access-denied';
//         } else {
//             // console.log(error);
//             switch (error.response && error.response?.status) {
//                 case 400:
//                     message = error.response && error.response.data
//                         ? `${error.response.data['message']}\n${error.response.data['error']}`
//                         : error.message || String(error);
//                     break;
//                 case 401:
//                     message = error.response?.data.message;
//                     if (error.response?.status === 401) {
//                         localStorage.removeItem('evoluz_token');
//                         localStorage.removeItem('evoluz_user');
//                         Cookies.remove('evoluz_user');
//                         sessionStorage.removeItem('evoluz_user');
//                         login();
//                     }
//                     break;
//                 case 403:
//                     message = 'Access Forbidden';
//                     break;
//                 case 404:
//                     message = error.response && error.response.data
//                         ? `${error.response.data['message']}\n${error.response.data['error']}`
//                         : error.message || String(error);
//                     break;
//                 default: {
//                     message =
//                         error.response && error.response.data ? error.response.data['message'] : error.message || error;
//                 }
//             }

//             return Promise.reject(message);
//         }
//     }
// );

axios.interceptors.response.use(
    response => response,
    error => {
        const status = error?.response?.status;
        const data = error?.response?.data;

        let errorPayload = {
            status: status,
            message: error.message || "Terjadi kesalahan",
            detail: data?.error || null,
            originalData: data // menyimpan data asli dari server
        };

        switch (status) {
            case 400:
            case 403:
            case 404:
                errorPayload.message = data?.message || "Request Error";
                break;

            case 401:
                localStorage.removeItem('evoluz_token');
                localStorage.removeItem('evoluz_user');
                Cookies.remove('evoluz_user');
                sessionStorage.removeItem('evoluz_user');
                login();
                errorPayload.message = data?.message || "Sesi berakhir";
                break;

            default:
                errorPayload.message = data?.message || "Request Error";
        }

        return Promise.reject(errorPayload);
    }
);

const AUTH_SESSION_KEY = 'evoluz_user';

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
    if (token) axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
    else delete axios.defaults.headers.common['Authorization'];
};

const getUserFromSession = () => {
    const user = sessionStorage.getItem(AUTH_SESSION_KEY);
    return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
};

const getUserFromLocalStorage = () => {
    const user = localStorage.getItem(AUTH_SESSION_KEY);
    return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
};

class APICore {
    /**
     * Fetches data from given url
     */
    get = (url, params, auth = null) => {
        let config = {};
        if (auth) {
            config.headers = { Authorization: 'Bearer ' + auth };
        }

        if (params) {
            const queryString = Object.keys(params)
                .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
                .join('&');
            return axios.get(`${url}?${queryString}`, config);
        } else {
            return axios.get(`${url}`, config);
        }
    };

    getFile = (url, params) => {
        let response;
        if (params) {
            var queryString = params
                ? Object.keys(params)
                    .map((key) => key + '=' + params[key])
                    .join('&')
                : '';
            response = axios.get(`${url}?${queryString}`, { responseType: 'blob' });
        } else {
            response = axios.get(`${url}`, { responseType: 'blob' });
        }
        return response;
    };

    getMultiple = (urls, params) => {
        const reqs = [];
        let queryString = '';
        if (params) {
            queryString = params
                ? Object.keys(params)
                    .map((key) => key + '=' + params[key])
                    .join('&')
                : '';
        }

        for (const url of urls) {
            reqs.push(axios.get(`${url}?${queryString}`));
        }
        return axios.all(reqs);
    };

    /**
     * post given data to url
     */
    create = (url, data) => {
        return axios.post(url, data);
    };

    /**
     * Updates patch data
     */
    updatePatch = (url, data) => {
        return axios.patch(url, data);
    };

    /**
     * Updates data
     */
    update = (url, data) => {
        return axios.put(url, data);
    };

    /**
     * Deletes data
     */
    delete = (url) => {
        return axios.delete(url);
    };

    /**
     * post given data to url with file
     */
    createWithFile = (url, data) => {
        console.log('DATA: ', data);
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }

        const config = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.post(url, formData, config);
    };


    uploadExcel = (url, formData) => {
        const config = {
            headers: {
                ...axios.defaults.headers,
                'Content-Type': 'multipart/form-data',
            },
        };
        return axios.post(url, formData, config);
    };


    /**
     * post given data to url with file
     */
    updateWithFile = (url, data) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }

        const config = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.put(url, formData, config);
    };

    isUserAuthenticated = () => {
        const user = this.getLoggedInUser();
        return user ? true : false;
    };

    setLoggedInUser = (session) => {
        if (session) {
            sessionStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(session));
            this.setLoggedInUserCookies(session);
        } else {
            sessionStorage.removeItem(AUTH_SESSION_KEY);
            localStorage.removeItem(AUTH_SESSION_KEY);
            localStorage.removeItem('evoluz_token');
            this.setLoggedInUserCookies(null);
        }
    };

    setLoggedInUserLocal = (local) => {
        if (local) {
            localStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(local));
        } else {
            localStorage.removeItem(AUTH_SESSION_KEY);
        }
    };

    setLoggedInUserCookies = (session) => {
        if (session) {
            Cookies.set(AUTH_SESSION_KEY, JSON.stringify(session), { expires: 7 });
        } else {
            Cookies.remove('evoluz_user');
        }
    };

    /**
     * Returns the logged in user
     */
    getLoggedInUser = () => {
        return getUserFromLocalStorage();
    };

    setUserInSession = (modifiedUser) => {
        let userInfo = sessionStorage.getItem(AUTH_SESSION_KEY);
        let userInfoLocal = localStorage.getItem(AUTH_SESSION_KEY);
        if (userInfo) {
            const { token, user } = JSON.parse(userInfo);
            this.setLoggedInUser({ token, ...user, ...modifiedUser });
        }
        if (userInfoLocal) {
            const { token, user } = JSON.parse(userInfo);
            this.setLoggedInUserLocal({ token, ...user, ...modifiedUser });
        }
    };

    getUserKeyCloak = () => {
        getUser().then(user => {

            if (user) {
                toast.success('User has been successfully loaded from store.', {
                    position: "top-right"
                });
                // setUser(user)
            } else {
                toast.error('You are not logged in.', {
                    position: "top-right"
                });
            }
        });
    };
}

/*
Check if token available in session
*/
let token = getUserFromLocalStorage();
if (token) {
    setAuthorization(localStorage.getItem('evoluz_token'));
}

export { APICore, setAuthorization, getUserFromSession, getUserFromLocalStorage };
